// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixMessage } from './PFixMessage';
export class MarginRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_MARGIN_REQ, fieldSet);
    }
    setType(type = 0) {
        this.FieldSet.SetField(FieldsFactory.FIELD_TYPE, type);
    }
}
